import { gql } from '@apollo/client';

export const COMPETENCE_ORDERS_LIST_QUERY = gql`
  query CompetenceOrders($pager: PagerInputNew, $filters: CompetenceOrdersFilterInput) {
    competenceOrders(pager: $pager, filters: $filters) {
      total
      values {
        competenceOrderId
        approvalTypeName
        statusName
      }
    }
  }
`;

export const COMPETENCE_ORDER_QUERY = gql`
  query competenceOrder($competenceOrderId: Int) {
    competenceOrder(competenceOrderId: $competenceOrderId) {
      appStatusId
      approvalTypeId
      approvalTypeName
      approvalTypeSiteId
      competenceOrderId
      expression
      siteId
      statusName
      stopAfterFirstTrueRuleYN
      documentTypeCode
      docStructureKey
      competenceOrderRules {
        approvalTypeLevelId
        approvalTypeLevelSiteId
        competenceOrderId
        competenceOrderRuleId
        decisionFormula
        expression
        isSystem
        levelName
        orderId
        ruleStatusCode
        ruleStatusId
        ruleStatusName
        siteId
      }
    }
  }
`;

export const APPROVAL_TYPES_QUERY = gql`
  query approvalType {
    approvalType {
      approvalTypeId
      approvalTypeLevels {
        approvalTypeId
        approvalTypeLevelId
        levelName
      }
      approvalTypeName
    }
  }
`;

export const APPLICATION_STATUS_QUERY = gql`
  query applicationStatus {
    applicationStatus {
      statusId
      statusName
    }
  }
`;

export const RULE_STATUS_QUERY = gql`
  query ruleStatus {
    ruleStatus {
      statusId
      statusName
    }
  }
`;

export const COMPETENCE_ORDER_FILTERS_QUERY = gql`
  {
    competenceOrderListFilters @client {
      fullTextFilter {
        value
      }
      approvalTypeName {
        value
      }
      statusName {
        value
      }
    }
  }
`;

export const DOCUMENT_TYPES_QUERY = gql`
  query documentTypes {
    documentTypes {
      id
      code
      name
    }
  }
`;